import { MARQUEE_KEYWORDS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_KEYWORDS, ...MARQUEE_KEYWORDS];
  return (
    <div className="relative border-y border-[#E3DCCB] bg-[#F1EDE3] py-5 overflow-hidden" data-testid="seo-marquee" aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((kw, i) => (
          <span key={i} className="flex items-center font-mono-tag text-xs uppercase tracking-[0.3em] text-slate-500">
            <span className="px-6">{kw}</span>
            <span className="text-teal-600">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
